import Link from "../Link";

const PHP = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/8" title={"OpenBootcamp PHP"} />
        </div>
    );
}

export default PHP;